import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { ICellRendererAngularComp } from "@bfx/ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";

@Component({
  selector: "deal-order-type",
  template: `<span
    [ngClass]="{ 'order-type order-type-sl': isSl }"
    class="order-type order-type-sl"
    >{{ value }}</span
  >`,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DealOrderTypeRenderer implements ICellRendererAngularComp {
  public isSl: boolean;
  public value: string;
  private previous: { isSl: boolean; value: string };

  constructor(public cd: ChangeDetectorRef) {
    this.previous = { isSl: this.isSl, value: this.value };
  }
  // called on init
  agInit(params: ICellRendererParams): void {
    this.doVal(params);
  }

  doVal(params: ICellRendererParams): boolean {
    this.previous.isSl = this.isSl;
    this.previous.value = this.value;

    this.value = params.value;

    switch (params.data[params.colDef.field]) {
      case CubiqTS.RequestOrderType.SL_ASK:
      case CubiqTS.RequestOrderType.SL_ATRATE:
      case CubiqTS.RequestOrderType.SL_BID:
      case CubiqTS.RequestOrderType.TSL:
      case CubiqTS.RequestOrderType.TSL_ASK:
      case CubiqTS.RequestOrderType.TSL_BID:
        this.isSl = true;
        break;
      default:
        this.isSl = false;
        break;
    }

    return this.value !== this.previous.value || this.isSl !== this.previous.isSl;
  }

  // called when the cell is refreshed
  refresh(params: ICellRendererParams): boolean {
    if (this.doVal(params)) {
      this.cd.markForCheck();
    }

    return true;
  }
}
